import { useEffect, useState } from "react";
import { Accordion, Button, Container } from "react-bootstrap";
import { FaTruck } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import BarraMenuHz from "../../../components/BarraMenoHz";
import LocalMsgModalSpinner from "../../../components/LocalMsgModalSpinner";
import MsgModalDialogEspecial from "../../../components/MsgModalDialogEspecial";
import { SetEntornoEmp } from "../../../redux/store/Actions";
import * as env from '../../../env';
import { httpApiGetText } from "../../../lib";
import { parametrosDetalle } from "./detalle";
import PanelTrazabilidad from "./PanelTrazabilidad";

// opción sintética que selecciona todo lo que el usuario tiene disponible en pantalla
const TODOS = "TODOS";

// Centro de prueba habilitado para consultar enero de 2026.
const CENTRO_PRUEBA = "4010 - CENTRO PRUEBA";

const TrazabilidadPage = () => {

    let emp: any = useSelector((state: any) => state.emp);
    const dispatch = useDispatch();

    const [sHCarga, setSHCarga] = useState(false);
    const [hbltBtnBuscar, setHbltBtnBuscar] = useState(true);
    const [periodo, setPeriodo] = useState(true);
    const [centros, setCentros] = useState([]);
    const [centrosSelected, setCentrosSelected] = useState([]);
    const [almacenesFiltrados, setAlmacenesFiltrados] = useState([]);
    const [almacenesSelected, setAlmacenesSelected] = useState([]);
    const [msgDlgShowApiResponse, setMsgDlgShowApiResponse] = useState(false);
    const [msgRespuestInv, setMsgRespuestInv] = useState("");
    const [recordsInventario, setRecordsInventario] = useState<any[]>([]);
    const [recordsSubInventario, setRecordsSubInventario] = useState<any[]>([]);
    const [recordsReconteo, setRecordsReconteo] = useState<any[]>([]);
    let [formData, setFormData] = useState({ Pais: "CL", Anno: "", Mes: "", Centro: "", Almacen: "", Centros: "", Almacenes: "" });
    const [periodoResultados, setPeriodoResultados] = useState(formData);

    const fmtFecha = (valor: any) => {
        if (!valor) return "";

        // el api mezcla dos formatos: ISO ("2026-01-07T10:33:27") y "dd-MM-yyyy HH:mm:ss".
        // El segundo hay que armarlo a mano porque Date lo interpreta como mes-día y convierte
        // el 7 de enero en 1 de julio, sin fallar
        const txt = valor.toString().trim();
        const ddmmaa = txt.match(/^(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2}):(\d{2}))?$/);
        const f = ddmmaa
            ? new Date(`${ddmmaa[3]}-${ddmmaa[2]}-${ddmmaa[1]}T${ddmmaa[4] ?? "00"}:${ddmmaa[5] ?? "00"}:${ddmmaa[6] ?? "00"}`)
            : new Date(txt);

        // el api devuelve 0001-01-01 cuando no hay fecha registrada
        if (isNaN(f.getTime()) || (f.getFullYear() < 1900)) return "";
        return f.toLocaleString("es-CL");
    }

    const columnsInventario: any[] = [
        { name: "Centro", selector: (row: any) => row.Centro, sortable: true, width: "100px" },
        { name: "Almacén", selector: (row: any) => row.Almacen, sortable: true, width: "110px" },
        { name: "Estado", selector: (row: any) => row.Estado_inv, sortable: true, width: "100px" },
        { name: "Últ. fecha bajada", selector: (row: any) => fmtFecha(row.Bajada_saldos), sortable: true, width: "170px", wrap: true },
        { name: "Usuario bajada", selector: (row: any) => (row.Bajada_usuario || "").trim(), sortable: true, width: "150px", wrap: true },
        { name: "Fecha de publicación", selector: (row: any) => fmtFecha(row.Publicado_fecha), sortable: true, width: "180px", wrap: true },
        { name: "Publicador", selector: (row: any) => (row.Publicado_usuario || "").trim(), sortable: true, width: "150px", wrap: true },
        { name: "Apertura", selector: (row: any) => (row.Usuario_apertura || "").trim(), sortable: true, width: "150px", wrap: true },
        { name: "Subinventario", selector: (row: any) => row.Subinventario, sortable: true, width: "140px" },
        { name: "Fecha y Hora Apertura", selector: (row: any) => fmtFecha(row.APERTURA_INV), sortable: true, width: "200px", wrap: true },
    ];

    const columnsSubInventario: any[] = [
        { name: "Centro", selector: (row: any) => row.Centro, sortable: true, width: "100px" },
        { name: "Almacén", selector: (row: any) => row.Almacen, sortable: true, width: "110px" },
        { name: "Ref", selector: (row: any) => row.Subinventario_Id, sortable: true, width: "160px", wrap: true },
        { name: "Familia", selector: (row: any) => row.Negocio, sortable: true, width: "150px", wrap: true },
        { name: "Cant. SKU", selector: (row: any) => row.Cant_Sku, format: (row: any) => row.Cant_Sku?.toLocaleString(), sortable: true, width: "120px", right: true },
        { name: "Estado", selector: (row: any) => row.Estado_Inv, sortable: true, width: "110px" },
        { name: "Apertura", selector: (row: any) => fmtFecha(row.Apertura_Fecha), sortable: true, width: "170px", wrap: true },
        { name: "Usuario apertura", selector: (row: any) => (row.Usuario_Apertura || "").trim(), sortable: true, width: "160px", wrap: true },
        { name: "Publicación", selector: (row: any) => fmtFecha(row.Publicado_Fecha), sortable: true, width: "170px", wrap: true },
        { name: "Fecha de bajada", selector: (row: any) => fmtFecha(row.Bajada_Saldos), sortable: true, width: "170px", wrap: true },
        { name: "Bajada de usuario", selector: (row: any) => (row.Bajada_Usuario || "").trim(), sortable: true, width: "160px", wrap: true },
    ];

    const columnsReconteo: any[] = [
        { name: "ID", selector: (row: any) => row.Reconteo_ref, sortable: true, width: "90px", wrap: true },
        // Por definición funcional, creación y publicación muestran Publicado_fecha.
        { name: "Fecha creación", selector: (row: any) => fmtFecha(row.Publicado_fecha), sortable: true, width: "170px", wrap: true },
        { name: "Fecha publicación", selector: (row: any) => fmtFecha(row.Publicado_fecha), sortable: true, width: "170px", wrap: true },
        { name: "Usuario publicación", selector: (row: any) => (row.Publicado_usuario || "").trim(), sortable: true, width: "170px", wrap: true },
        { name: "Centro", selector: (row: any) => row.Centro, sortable: true, width: "100px" },
        { name: "Almacén", selector: (row: any) => row.Almacen, sortable: true, width: "110px" },
        { name: "Estado", selector: (row: any) => row.Estado_inv, sortable: true, width: "110px" },
    ];

    //arma el formato que esperan los apis: "centro|centro" y "almacen|almacen"
    const armaCentroAlmacen = (almacenes: any) => {

        const cnts: string[] = [];
        const almcs: string[] = [];

        almacenes.map((dato: any) => {
            const alm = dato.key.split(' - ')[0].trim();
            if (!cnts.includes(dato.cat)) cnts.push(dato.cat);
            if (!almcs.includes(alm)) almcs.push(alm);
        });

        return { Centros: cnts.join("|"), Almacenes: almcs.join("|") };
    }

    const habilitaBuscar = (lng: number) => {

        setHbltBtnBuscar(!lng);

    }

    //filtra los almacenes disponibles según los centros seleccionados
    const filtraAlmacenes = (centrosSeleccionados: any) => {

        if (centrosSeleccionados.length > 0) {
            const almacenes: any = [];
            centrosSeleccionados.map((dato: any) => {
                //compara contra el centro del almacén: con includes, un código que aparezca en el
                //número o el nombre del almacén lo haría calzar con un centro que no le corresponde
                const alma = emp.almacenes.filter((alm: string) => alm.split(' - ')[0].trim() === dato.cat);
                //organiza la estructura de almacenes así: {cat: id, key: label} para mostrar en el multiselect
                alma.map((dt: string) => {
                    const cnt = dato.cat;
                    const almcn = `${dt.split(' - ')[1]} - ${dt.split(' - ')[2]}`;
                    almacenes.push({ cat: cnt, key: almcn });
                });
            });

            setAlmacenesFiltrados(almacenes);
        } else {
            setAlmacenesFiltrados([]);
        }
    }

    const hndlrPeriodo = async (evnt: any) => {

        const f: Date = evnt.target.value;
        const yy = f.toString().split('-')[0];
        const mm = f.toString().split('-')[1];

        emp = { ...emp, periodoDefault: `${yy}-${mm}` };
        dispatch(SetEntornoEmp({ ...emp }));

        sessionStorage.setItem("entorno", JSON.stringify(emp));

        formData = { ...formData, Anno: yy, Mes: mm };
        setFormData(formData);

        setPeriodo(!mm);
    }

    //aplica la selección de centros: si viene TODOS, toma los centros disponibles en pantalla
    const aplicaCentros = (seleccion: any) => {

        const cnts = seleccion.some((dato: any) => dato.cat === TODOS) ? [...centros] : seleccion;

        setCentrosSelected(cnts);
        filtraAlmacenes(cnts);

        //conserva sólo los almacenes cuyos centros siguen seleccionados
        const almcs = almacenesSelected.filter((dato: any) => cnts.some((cnt: any) => cnt.cat === dato.cat));
        setAlmacenesSelected(almcs);
        actualizaCentroAlmacen(almcs);
        habilitaBuscar(almcs.length);
    }

    const onSelectedOptionCenter = (e: any) => {

        aplicaCentros(e);

    }

    const onRemoveOptionCenter = (e: any) => {

        aplicaCentros(e);

    }

    //aplica la selección de almacenes: si viene TODOS, toma los almacenes disponibles en pantalla
    const aplicaAlmacenes = (seleccion: any) => {

        const almcs = seleccion.some((dato: any) => dato.cat === TODOS) ? [...almacenesFiltrados] : seleccion;

        setAlmacenesSelected(almcs);
        actualizaCentroAlmacen(almcs);
        habilitaBuscar(almcs.length);
    }

    const onSelectedOptionAlmacen = (e: any) => {

        aplicaAlmacenes(e);

    }

    const onRemoveOptionAlmacen = (e: any) => {

        aplicaAlmacenes(e);

    }

    const actualizaCentroAlmacen = (almacenes: any) => {

        const cntAlm = armaCentroAlmacen(almacenes);

        formData = {
            ...formData,
            Centro: almacenes.length > 0 ? almacenes[0].cat : "",
            Almacen: almacenes.length > 0 ? almacenes[0].key.split(' - ')[0].trim() : "",
            Centros: cntAlm.Centros,
            Almacenes: cntAlm.Almacenes
        };
        setFormData(formData);

        if (almacenes.length > 0) {
            emp = { ...emp, centroDefault: formData.Centro, almacenDefault: formData.Almacen };
            dispatch(SetEntornoEmp({ ...emp }));
            sessionStorage.setItem("entorno", JSON.stringify(emp));
        }
    }

    const cabeceras = {
        'Content-Type': 'application/json',
        'Rosen-API-Key': `${env.REACT_APP_Rosen_API_Key}`,
        'Rosen-API-Secret': `${env.REACT_APP_Rosen_API_Secret}`,
    };

    // Consulta genérica: nunca lanza. Si el período no está abierto el api responde 400 con
    // {Message}; en ese caso la pestaña simplemente queda sin datos, sin interrumpir al usuario.
    // Ante una caída de red httpApiGetText devuelve texto plano, por eso el parseo va protegido.
    const consultaApi = async (recurso: string, pestania: string) => {

        const response = await httpApiGetText(recurso, cabeceras);

        let arrDta: any = null;
        try {
            arrDta = JSON.parse(response.message);
        } catch (e) {
            console.log(`Trazabilidad - ${pestania}: `, response.message);
            return null;
        }

        if (response.code >= 400) {
            console.log(`Trazabilidad - ${pestania}: `, arrDta.Message ?? response.message);
            return null;
        }

        return arrDta;
    }

    // el api normalmente responde un arreglo, pero ante un registro único o un formato inesperado
    // puede llegar un objeto: se normaliza para que las grillas nunca reciban algo que no sea lista
    const comoArreglo = (dta: any) => {

        if (Array.isArray(dta)) return dta;
        if (dta && typeof dta === "object") return [dta];
        return [];
    }

    // api/Periodo entrega la información de la pestaña Inventario.
    // Recibe los centros y almacenes separados por "|".
    const buscaInventario = async () => {

        const recurso = `${env.REACT_APP_API_URL}/api/Periodo?pais=${formData.Pais}&anno=${formData.Anno}&mes=${formData.Mes}&centros=${encodeURIComponent(formData.Centros)}&almacenes=${encodeURIComponent(formData.Almacenes)}`;
        const arrDta = await consultaApi(recurso, "Inventario");

        if (arrDta) setRecordsInventario(comoArreglo(arrDta));
    }

    // api/InventarioTraza entrega la información de la pestaña Sub-inventario.
    // Recibe los centros y almacenes separados por "|".
    const buscaSubInventario = async () => {

        const recurso = `${env.REACT_APP_API_URL}/api/InventarioTraza?pais=${formData.Pais}&anno=${formData.Anno}&mes=${formData.Mes}&centros=${encodeURIComponent(formData.Centros)}&almacenes=${encodeURIComponent(formData.Almacenes)}`;
        const arrDta = await consultaApi(recurso, "Sub-inventario");

        if (!arrDta) return;

        // cuando el api agrupa por centro/almacén se aplana el detalle para mostrarlo en una sola
        // grilla; si ya responde las filas directamente se toman tal cual
        const detalle: any = [];
        comoArreglo(arrDta).map((dato: any) => {
            if (dato && dato.InventarioSubDetalle) {
                comoArreglo(dato.InventarioSubDetalle).map((sub: any) => detalle.push(sub));
            } else {
                detalle.push(dato);
            }
        });

        setRecordsSubInventario(detalle);
    }

    // api/InventarioTraza con los filtros de estado entrega la información de la pestaña Reconteo.
    // Recibe los centros y almacenes separados por "|".
    // Es una consulta propia de Reconteo, independiente de la de Sub-inventario: comparte el
    // recurso pero se distingue por Estado_inv y Bajada_estado, pendientes de sus valores.
    const buscaReconteo = async () => {

        const recurso = `${env.REACT_APP_API_URL}/api/InventarioTraza?Pais=${formData.Pais}&Anno=${formData.Anno}&Mes=${formData.Mes}&centros=${encodeURIComponent(formData.Centros)}&almacenes=${encodeURIComponent(formData.Almacenes)}&Estado_inv=&Bajada_estado=`;
        const arrDta = await consultaApi(recurso, "Reconteo");

        if (arrDta) setRecordsReconteo(comoArreglo(arrDta));
    }

    // consulta el detalle por SKU de las filas a exportar; devuelve null si no se pudo obtener
    const buscaDetalle = async (pestania: string, filas: any[]) => {

        setSHCarga(true);
        try {
            const parametros = parametrosDetalle(pestania, filas);
            const recurso = pestania === "reconteo" ? "InventarioTrazaReconteo" : "InventarioTrazaDetalle";
            const periodo = `pais=${periodoResultados.Pais}&anno=${periodoResultados.Anno}&mes=${periodoResultados.Mes}`;
            const detalle: any[] = [];
            for (const parametro of parametros) {
                const arrDta = await consultaApi(`${env.REACT_APP_API_URL}/api/${recurso}?${periodo}&${parametro}`, `Detalle ${pestania}`);
                if (arrDta === null) throw new Error("No se pudo obtener todo el detalle seleccionado. Intente exportar nuevamente.");
                detalle.push(...comoArreglo(arrDta));
            }

            if (detalle.length === 0) {
                setMsgRespuestInv("No se encontró detalle para exportar de los registros seleccionados.");
                setMsgDlgShowApiResponse(true);
                return null;
            }

            return detalle;
        } catch (error) {
            setMsgRespuestInv(error instanceof Error ? error.message : "No se pudo obtener el detalle seleccionado.");
            setMsgDlgShowApiResponse(true);
            return null;
        } finally {
            setSHCarga(false);
        }
    }

    const hndlrBtnBuscar = async () => {

        setPeriodoResultados({ ...formData });
        setRecordsInventario([]);
        setRecordsSubInventario([]);
        setRecordsReconteo([]);

        setSHCarga(true);
        try {
            // cada consulta es independiente: la pestaña que no tenga período abierto
            // queda sin datos y las demás muestran su información igual
            await Promise.all([
                buscaInventario(),
                buscaSubInventario(),
                buscaReconteo(),
            ]);
        } finally {
            setSHCarga(false);
        }
    }

    const MsgDlghandlerResponseApi = () => {
        setMsgDlgShowApiResponse(false);
    }

    // emp se rehidrata desde sessionStorage en BarraMenuHz (useEffect), por lo que en la primera
    // renderización emp.centros aún viene vacío. Se recarga cuando la sesión queda disponible.
    useEffect(() => {

        const preFiltros = () => {
            if ((emp.periodoDefault !== "")) {
                formData = { ...formData, Anno: emp.periodoDefault.split("-")[0], Mes: emp.periodoDefault.split("-")[1] };
                setFormData(formData);
                setPeriodo(false);
            }
            if ((emp.centroDefault !== "")) {
                formData = { ...formData, Centro: emp.centroDefault.split("-")[0].trim() };
                setFormData(formData);
            }
            if ((emp.almacenDefault !== "")) {
                formData = { ...formData, Almacen: emp.almacenDefault.split("-")[0].trim() };
                setFormData(formData);
            }
        }

        preFiltros();

        const centros: any = [];
        const disponibles = emp.centros.some((dt: string) => dt.split(' - ')[0].trim() === "4010")
            ? emp.centros : [...emp.centros, CENTRO_PRUEBA];
        disponibles.map((dt: string) => {
            const cnt = dt.split(' - ')[0].trim();
            const nmCnt = (dt.split(' - ').length > 1) ? `${cnt} - ${dt.split(' - ')[1]}` : cnt;
            centros.push({ cat: cnt, key: nmCnt });
        });
        setCentros(centros);

    }, [emp.centros]);

    return (
        <Container fluid>
            <BarraMenuHz />
            <div >
                <div className="text-primary  ms-3 mt-3">
                    Home / Inventario / Trazabilidad
                </div>
                <div className="h4 mt-4 mb-4 ms-1">TRAZABILIDAD DE INVENTARIO</div>
            </div>
            <Container fluid >
                <Accordion className="mb-3" defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0" className="border shadow ">
                        <Accordion.Header><div className=" h5 text-dark">Selector de Períodos</div></Accordion.Header>
                        <Accordion.Body>
                            <div className="p-4 " style={{ backgroundColor: "white" }}>
                                <div className="row d-flex flex-row">
                                    <Container className="mb-3 d-flex flex-column col-md-12 col-lg-3">
                                        <label className="m-2 ">Periodos disponibles *</label>
                                        <input type="month" id="periodo" size={8} className="ms-2"
                                            onChange={hndlrPeriodo}
                                            value={`${formData.Anno}-${formData.Mes}`}
                                            min="1990-01" max="9999-12"
                                        />
                                    </Container>
                                </div>

                                <div className="align-middle mt-4">
                                    <FaTruck className="h5" />
                                    <label className="ms-2 h4 ">Centro y Almacen</label>
                                </div>
                                <hr className="t-0 m-0 mb-3" />

                                <div className="row d-flex flex-row mb-3">
                                    <Container fluid className="mb-3 col-md-12 col-lg-6" >
                                        <label className="form-label">Seleccionar Centro de distribución *</label>
                                        <div>
                                            <Multiselect className="" aria-label="Default select example"
                                                onSelect={(e: any) => onSelectedOptionCenter(e)}
                                                onRemove={(e: any) => onRemoveOptionCenter(e)}
                                                options={(centros.length > centrosSelected.length) ? [{ cat: TODOS, key: TODOS }, ...centros] : centros}
                                                displayValue="key"
                                                placeholder="Centros de distribución"
                                                selectedValues={centrosSelected}
                                            />
                                        </div>
                                    </Container>
                                    <Container fluid className="mb-3  col-md-12 col-lg-6" >
                                        <label className="form-label">Seleccionar Almacen *</label>
                                        <div>
                                            <Multiselect className="" aria-label="Default select example"
                                                onSelect={(e: any) => onSelectedOptionAlmacen(e)}
                                                onRemove={(e: any) => onRemoveOptionAlmacen(e)}
                                                options={(almacenesFiltrados.length > almacenesSelected.length) ? [{ cat: TODOS, key: TODOS }, ...almacenesFiltrados] : almacenesFiltrados}
                                                displayValue="key"
                                                placeholder="Almacen(es)"
                                                selectedValues={almacenesSelected}
                                            />
                                        </div>
                                    </Container>
                                </div>

                                <div className="text-end">
                                    <Button type="button" className="btn border border-0" style={{ backgroundColor: "#00B5B8" }}
                                        disabled={hbltBtnBuscar || periodo} onClick={() => hndlrBtnBuscar()}
                                    >
                                        Buscar
                                    </Button>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <Accordion className="mb-3" defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0" className="border shadow ">
                        <Accordion.Header></Accordion.Header>
                        <Accordion.Body>
                            <div className="row d-flex flex-row  mt-4 mb-4">
                                <nav>
                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                        <a className="nav-link active" href="#nav-inventario" id="nav-inventario-tab" data-bs-toggle="tab" data-bs-target="#nav-inventario" type="button" role="tab" aria-controls="nav-inventario" aria-selected="false">Inventario</a>
                                        <a className="nav-link" href="#nav-subinventario" id="nav-subinventario-tab" data-bs-toggle="tab" data-bs-target="#nav-subinventario" type="button" role="tab" aria-controls="nav-subinventario" aria-selected="false">Sub-inventario</a>
                                        <a className="nav-link" href="#nav-reconteo" id="nav-reconteo-tab" data-bs-toggle="tab" data-bs-target="#nav-reconteo" type="button" role="tab" aria-controls="nav-reconteo" aria-selected="false">Reconteo</a>
                                    </div>
                                </nav>
                                <div className="tab-content " id="nav-tabContent" style={{ backgroundColor: "white" }}>
                                    <div className="tab-pane fade show active" id="nav-inventario" role="tabpanel" aria-labelledby="nav-inventario-tab">
                                        <PanelTrazabilidad id="inventario" data={recordsInventario} formData={periodoResultados} columns={columnsInventario} buscaDetalle={buscaDetalle} />
                                    </div>
                                    <div className="tab-pane fade" id="nav-subinventario" role="tabpanel" aria-labelledby="nav-subinventario-tab">
                                        <PanelTrazabilidad id="subinventario" data={recordsSubInventario} formData={periodoResultados} columns={columnsSubInventario} buscaDetalle={buscaDetalle} />
                                    </div>
                                    <div className="tab-pane fade" id="nav-reconteo" role="tabpanel" aria-labelledby="nav-reconteo-tab">
                                        <PanelTrazabilidad id="reconteo" data={recordsReconteo} formData={periodoResultados} columns={columnsReconteo} buscaDetalle={buscaDetalle} />
                                    </div>
                                </div>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>

            {/*********** cuadro de dialogo para msj de api **********/}
            <MsgModalDialogEspecial
                Show={msgDlgShowApiResponse}
                Title={`Trazabilidad de inventario`}
                Icon="x"
                Message={msgRespuestInv}
                BtnOkName="Aceptar"
                BtnNokName=""
                HandlerClickOk={() => MsgDlghandlerResponseApi()}
                HanlerdClickNok={null}
            />

            <LocalMsgModalSpinner
                Show={sHCarga}
                text="Un momento por favor, procesando..."
                color="#FF7588"
            />
        </Container>
    );
}

export default TrazabilidadPage;
